import ons from "onsenui";
import * as React from "react";
import * as Ons from "react-onsenui";
import StarRatingComponent from "react-star-rating-component";
import { Analytics } from "../Analytics";
import { getLocalStorageItem, setLocalStorageItem } from "../storage_utils";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppVersion } from "../version";

const LOCAL_STORAGE_APP_REVIEW = "appReview";
const LOCAL_STORAGE_APP_VERSION = "appVersion";

interface AppRatingProps {}

interface AppRatingState {
  showDialog: boolean;
  shouldRate: boolean;
  alreadyRated: boolean;
}

export class AppRating extends React.Component<AppRatingProps, AppRatingState> {
  constructor(props: AppRatingProps) {
    super(props);
    this.state = {
      showDialog: false,
      shouldRate: false,
      alreadyRated: false,
    };

    document.addEventListener("pinOnUnlockEvent", this.renderDialg);
  }

  componentDidMount() {
    this.setShouldRate();
  }

  componentWillUnmount() {
    document.removeEventListener("pinOnUnlockEvent", this.renderDialg);
  }

  private renderDialg = () => {
    this.setState({ showDialog: true });
  };

  async setShouldRate() {
    const DAY = 24 * 60 * 60 * 1000;
    const localStorageAppReview = await getLocalStorageItem(LOCAL_STORAGE_APP_REVIEW);
    const localStorageAppVersion = await getLocalStorageItem(LOCAL_STORAGE_APP_VERSION);
    if (localStorageAppReview !== "SUCCESS") {
      if (localStorageAppReview === null || localStorageAppVersion !== AppVersion) {
        // Set last app review to 4 days ago in order to display the next one in 3 days
        setLocalStorageItem(LOCAL_STORAGE_APP_REVIEW, (Date.now() - DAY * 4).toString());
        // Set app version in localstorage
        setLocalStorageItem(LOCAL_STORAGE_APP_VERSION, AppVersion);
      }
      if ((Date.now() - parseInt(localStorageAppReview as string, 10)) / DAY >= 7) {
        this.setState({ shouldRate: true });
        setLocalStorageItem(LOCAL_STORAGE_APP_REVIEW, Date.now().toString());
      }
    }
  }
  launchAppReview(rating: number) {
    const LaunchReview: any = (window as any).LaunchReview;

    Analytics.track("App rated", { RATING: rating });

    if (rating === 5) {
      let appId: string;

      if (ons.platform.isIOS()) {
        appId = "1165814775";
      } else {
        appId = "com.medflyt.iphone";
      }

      LaunchReview.launch(
        undefined,
        (err: string) => {
          throw new Error(err);
        },
        appId
      );

      this.setState({ alreadyRated: true, shouldRate: false });
    }
    this.setState({ alreadyRated: true });
  }

  render() {
    if (
      (window as any).device &&
      (window as any).device.platform !== "browser" &&
      this.state.showDialog
    ) {
      return (
        <Ons.AlertDialog
          isOpen={this.state.shouldRate}
          onCancel={() => this.setState({ shouldRate: false })}
          animation="none"
          modifier="material"
        >
          <div
            style={{
              display: this.state.alreadyRated ? "none" : "flex",
              opacity: this.state.alreadyRated ? 0 : 1,
            }}
            className="RatingDialog"
          >
            <h4 className="RatingDialog__label">{translate(STRINGS.HOW_DO_YOU_RATE_MEDFLYT)}</h4>
            <StarRatingComponent
              name="apprate"
              starCount={5}
              onStarClick={(rating: number) => this.launchAppReview(rating)}
            />
          </div>
          <div
            style={{
              height: this.state.alreadyRated ? "auto" : 0,
              padding: this.state.alreadyRated ? "5px 5px 35px 5px" : 0,
            }}
            className="RatingDialog"
          >
            <h4
              style={{ opacity: this.state.alreadyRated ? 1 : 0 }}
              className="RatingDialog__label"
            >
              {translate(STRINGS.THANK_YOU_FOR_YOUR_FEEDBACK)}
            </h4>
          </div>
        </Ons.AlertDialog>
      );
    } else {
      return null;
    }
  }
}
